<div class="sidebar-feedback container-fluid p-4"><app-loading [isLoading]="isLoading">
    <div class="row">
      <div class="col-12"><button class="btn-close d-block ms-auto me-0" type="button" (click)="close()"></button></div>
    </div>
    <div class="row mt-4" *ngIf="feedback">
      <div class="col-12"><app-sidebar-feedback-question-set [feedback]="feedback"></app-sidebar-feedback-question-set></div>
    </div>
  </app-loading></div>
